import { QueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import minMax from 'dayjs/plugin/minMax';
import objectSupport from 'dayjs/plugin/objectSupport';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { enableMapSet } from 'immer';

/**
 * Register the dayjs plugins and immer features the component tree relies on.
 * Called once per JavaScript realm before rendering — by the app bootstrapper
 * and by the embeddable library entry. Idempotent.
 */
export function setupRuntime() {
  dayjs.extend(duration);
  dayjs.extend(minMax);
  dayjs.extend(objectSupport);
  dayjs.extend(timezone);
  dayjs.extend(utc);
  dayjs.tz.setDefault('UTC');

  enableMapSet();
}

/** Shared spring transition applied through `MotionConfig` at every render root. */
export const motionConfigTransition = {
  type: 'spring',
  duration: 0.5,
  bounce: 0.15,
} as const;

/** Create a `QueryClient` with the workspace-standard cache defaults. */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
      },
    },
  });
}
